import $ from 'jquery';

/**
 * @param {number} timer
 * @param {number} time
 * @param {Function} callback
 * @param {Boolean} interval
 *
 * @return {number}
 */
export function startTimer(timer, time, callback, interval = false) {
    clearTimer(timer);

    return interval
        ? setInterval(callback, time)
        : setTimeout(callback, time);
}

/**
 * @param {number|null} timer
 * @param {Boolean} interval
 *
 * @return {void}
 */
export function clearTimer(timer, interval = false) {
    if (timer) {
        if (interval) {
            clearInterval(timer);
        } else {
            clearTimeout(timer);
        }

        timer = null;
    }
}

/**
 * @param {Object} $el
 * @param {number} threshold if 0, the element is considered in the viewport as soon as it enters.
 *                   if 1, the element is considered in the viewport only when it's fully inside
 *                   value in percentage (1 >= h >= 0);
 *
 * @return {boolean}
 */
export function inViewport($el, threshold = 0) {
    let elHeight = $el.outerHeight(),
        scrolled = $(window).scrollTop(),
        viewed = scrolled + $(window).height(),
        elTop = $el.offset().top,
        elBottom = elTop + elHeight;

    return (
        elTop + elHeight * threshold <= viewed &&
        elBottom - elHeight * threshold >= scrolled
    );
}
